<template>
  <Multiselect
    :id="htmlId"
    v-model="valueHandler"
    label="label"
    trackBy="id"
    valueByPath="id"
    :options="options"
    :disabled="isDisabled"
    :max="multiple"
    :afterList="projectLock ? ['Zobrazit všechny...', showAll] : []"
  >
  </Multiselect>
</template>

<script>
import _ from 'lodash'
import DataTypeMixin from 'CORE/mixins/dataType'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext.vue'
import { createDataTypeValue } from '../utils'
import labels from 'CORE/utils/labels'

export default {
    name: 'LinkPersonResourceInput',
    components: {
        Multiselect,
    },
    mixins: [
        DataTypeMixin,
    ],
    props: {
        resFunction: {
            type: String,
            reqired: true,
            default: _ => null,
        },
    },
    data() {
        return {
            projectLock: true,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', [])
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    if (this.isZpracovatel() || this.visibility === 0) {
                        this.$emit('input', createDataTypeValue(value))
                    }
                }
            },
        },
        isDisabled() {
          if(this.isZpracovatel())
            return false

          return this.visibility > 0
        },
        options() {
            const resTypeFunc = this.$store.getters.resourceTypeFunctionByName(this.resFunction)

            const sameProjectPropertyTypeValue = _.get(this.meta, `project.propertyValues.${this.id}.value.value`)

            // console.info(sameProjectPropertyTypeValue)

            let resources = []

            if (_.isArray(sameProjectPropertyTypeValue) && this.projectLock === true) {
                resources = _.map(_.union(sameProjectPropertyTypeValue, this.valueHandler), id => {
                    return this.$store.getters.resourceById(id)
                })
            } else {
                resources = _.filter(
                    this.$store.getters.resources,
                    { resourceTypeFunction: { id: _.get(resTypeFunc, 'id') } }
                )
            }

            return _.map(resources, r => {
                return {
                    id: _.get(r, 'id'),
                    label: labels.resource(r),
                }
            })
        },
        multiple() {
            return _.get(this.propertyType, 'multiple', -1)
        },
    },
    mounted() {
        const isAssignee = _.get(this.propertyType, 'settings.systags.assignee', false)
        if (isAssignee) {
            this.projectLock = true
        } else {
            this.projectLock = false
        }
    },
    methods: {
        showAll() {
            this.projectLock = false
        },
        isZpracovatel() {
          let found = false
          if(this.value === null) return true
          this.value.value.value.forEach(zpracovatelPropertyId => {
            const zpracovatelUserId = _.get(this.$store.getters.resourceById(zpracovatelPropertyId), 'propertyValues.company-uzivatel.value.value', '')[0]
            if(zpracovatelUserId === this.$store.getters.currentUser.id){
              found = true
              return
            }
          })
          return found
        }
    },
}
</script>
